/**
 * Capture ?ref=CODE from the URL on landing pages and stash it in localStorage.
 * AuthCallback later reads it and forwards to /api/auth/session?ref=CODE so the
 * referral attribution survives the OAuth round-trip.
 */
const KEY = 'gv_ref_code';
const TTL_MS = 1000 * 60 * 60 * 24 * 60; // 60 days

export function captureRefFromUrl() {
  if (typeof window === 'undefined') return;
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = (params.get('ref') || '').trim().toUpperCase();
    if (!ref) return;
    if (!/^[A-Z0-9]{4,12}$/.test(ref)) return;
    localStorage.setItem(KEY, JSON.stringify({ code: ref, at: Date.now() }));
  } catch { /* ignore */ }
}

export function readStoredRef() {
  if (typeof window === 'undefined') return '';
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return '';
    const parsed = JSON.parse(raw);
    if (!parsed?.code || !parsed?.at) return '';
    if (Date.now() - parsed.at > TTL_MS) { localStorage.removeItem(KEY); return ''; }
    return parsed.code;
  } catch { return ''; }
}

export function clearStoredRef() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
